export const common = {
  nav: {
    products: 'Products',
    gallery: 'Gallery',
    services: 'Services',
    technologies: 'Technologies',
    industries: 'Industries',
    about: 'About',
    contact: 'Contact',
    requestStudy: 'Request Study',
    toggleMenu: 'Toggle menu',
  },
  footer: {
    description: 'Leading provider of advanced industrial filtration, purification, and separation solutions for global industries.',
    isoCertified: 'ISO Certified Quality',
    solutions: 'Solutions',
    company: 'Company',
    contact: 'Contact',
    followUs: 'Follow Us',
    address: 'Address',
    phone: 'Phone',
    email: 'Email',
    businessHours: 'Business Hours',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    cookiePolicy: 'Cookie Policy',
    allRightsReserved: 'All rights reserved.',
    poweredBy: 'Powered by Bradnova',
    steEinaLtdInternational: 'Ste EINA LTD International',
  },
  actions: {
    learnMore: 'Learn More',
    viewAll: 'View All',
    exploreSolutions: 'Explore Solutions',
    discoverMore: 'Discover Our Solutions',
    contactUs: 'Contact Us',
    viewProducts: 'View Products',
    exploreProducts: 'Explore All Products',
  },
  language: {
    english: 'English',
    french: 'Français',
    selectLanguage: 'Select Language',
  },
};